import { render, staticRenderFns } from "./TestRecordDetail.vue?vue&type=template&id=a5bc6c02&scoped=true&lang=true&"
import script from "./TestRecordDetail.vue?vue&type=script&lang=js&"
export * from "./TestRecordDetail.vue?vue&type=script&lang=js&"
import style0 from "./TestRecordDetail.vue?vue&type=style&index=0&id=a5bc6c02&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5bc6c02",
  null
  
)

export default component.exports